import { BuildResponse, TrainResponse, VillageEconomy } from "@empire/shared";
import { request } from "./client.js";

/**
 * The village economy, from the client's side (S8-4).
 *
 * Every reply is parsed with the same Zod schema the server validates against,
 * so a server that starts sending something else fails here, loudly, rather
 * than three screens later as a price that is quietly wrong.
 */

export function fetchEconomy(villageId: string, token: string): Promise<VillageEconomy> {
  return request(`/api/v1/villages/${villageId}/economy`, VillageEconomy, { token });
}

export function startBuild(
  villageId: string,
  token: string,
  building: string
): Promise<BuildResponse> {
  return request(`/api/v1/villages/${villageId}/build`, BuildResponse, {
    method: "POST",
    token,
    body: { building },
  });
}

export function cancelBuild(
  villageId: string,
  token: string,
  queueId: string
): Promise<BuildResponse> {
  return request(`/api/v1/villages/${villageId}/build/${queueId}`, BuildResponse, {
    method: "DELETE",
    token,
  });
}

export function trainUnits(
  villageId: string,
  token: string,
  unit: string,
  count: number
): Promise<TrainResponse> {
  return request(`/api/v1/villages/${villageId}/train`, TrainResponse, {
    method: "POST",
    token,
    body: { unit, count },
  });
}

export function cancelTraining(
  villageId: string,
  token: string,
  orderId: string
): Promise<TrainResponse> {
  return request(`/api/v1/villages/${villageId}/train/${orderId}`, TrainResponse, {
    method: "DELETE",
    token,
  });
}
